import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiManager from '../../api-manager/ApiManager.component';
import ApiManagerCustomer from '../../api-manager/ApiManagerCustomer.component';
import Header from "../header/header";
import Footer from "../footer/footer";

const UserSelectionPage = () => {
  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const savedPhone = localStorage.getItem('phoneNumber');
    const otpVerified = localStorage.getItem('isOtpVerified');
    if (!savedPhone || otpVerified !== 'true') {
      navigate('/login'); 
    } else {
      setMsisdn(savedPhone);
    }
  }, [navigate]);

  const handleUserClick = async () => {
    try {
      setIsLoading(true);
      localStorage.setItem('userType', 'CUSTOMER');

      const customerData = await ApiManagerCustomer.fetchCustomerAccountDetails(msisdn);

      if (customerData && customerData.id > 0) {
        localStorage.setItem('customerData', JSON.stringify(customerData));
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userData', JSON.stringify(customerData));
        navigate('/', { state: { paramKey: customerData } });
      } else {
        navigate('/user-registration', { state: { paramKey: customerData } });
      }
    } catch (error) {
      console.error('User selection error:', error);
      setErrorMessage('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleAstrologerClick = async () => {
    try {
      setIsLoading(true);
      localStorage.setItem('userType', 'ASTROLOGER');

      const astrologerData = await ApiManager.fetchAstrologerAccountDetails(msisdn);

      if (astrologerData && astrologerData.astrologerId > 0) {
        localStorage.setItem('astrologerData', JSON.stringify(astrologerData));
        localStorage.setItem('isLoggedIn', 'false');
        localStorage.setItem('userData', JSON.stringify(astrologerData));
        navigate('/app-downloads', { state: { paramKey: astrologerData } });
      } else {
        navigate('/astrologer-registration', { state: { paramKey: astrologerData } });
      }
    } catch (error) {
      console.error('Astrologer selection error:', error);
      setErrorMessage('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Header />
    <div className="full-page-layout">
      <div className="center-content">
        <div className="container-selection">
          <div className="logo">
            <img src={require("../../assets/AstrobhagyaLogo.webp")} alt="AstroBhagya Logo" />
          </div>
          <div className="logo">
            <img src={require("../../assets/AstrobhagyaName.webp")} alt="AstroBhagya Name" />
          </div>
          <h1>GET STARTED</h1>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <button className="bttn user-button" onClick={handleUserClick} disabled={isLoading}>
            {isLoading ? 'Loading...' : 'Are you a User?'}
          </button>
          <button className="bttn astrologer-button" onClick={handleAstrologerClick} disabled={isLoading}>
            {isLoading ? 'Loading...' : 'Are you an Astrologer?'}
          </button>
        </div>
      </div>
    </div>
    <Footer />
    </div>
  );
};

export default UserSelectionPage;
